"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediafilePatternRule = void 0;
var mediafilePatternRule = function (aggregateValues, tags) {
    return tags.find(function (tag) { return aggregateValues.includes(tag); });
};
exports.mediafilePatternRule = mediafilePatternRule;
//# sourceMappingURL=mediafilePatternRule.js.map